export default "__VITE_ASSET__D7L6Rza$__"